import {
  Box,
  Button,
  Center,
  Group,
  Image,
  TextInput,
} from "@mantine/core";
import { notifications } from "@mantine/notifications";
import React, { useEffect, useReducer } from "react";

import { IconAlertCircle, IconCircleCheck } from "@tabler/icons-react";
import logo from "../../assets/logo.png";
import { isNotEmpty, useForm } from "@mantine/form";
import "./LoginPage.css";
import { Link, useNavigate } from "react-router-dom";
import { IconInfoCircle } from '@tabler/icons-react';
import { url } from "../../settings/linkUrl";


export default function LoginPage() {
  const nav = useNavigate();
  const initialState = {
    loading: "",
    error: "",
    data: [],
  };

  function apiReducer(state: any, action: any) {
    switch (action.type) {
      case "DATA_FETCH_START":
        return { ...state, loading: "yes" };
      case "DATA_FETCH_SUCCESS":
        return { ...state, loading: "", data: action.payload };
      case "DATA_FETCH_FAILURE":
        return { ...state, loading: "", error: action.payload };
      default:
        return state;
    }
  }

  const [data, dispatch] = useReducer(apiReducer, initialState);

  const form = useForm({
    initialValues: {
      username: "",
    },

    validate: {
      username: isNotEmpty("ระบุรหัสบัตรประจำตัวประชาชน"),
    },
  });

  const funcSubmit = () => {
    dispatch({ type: "DATA_FETCH_START" });
    const token = localStorage.getItem("token");
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(form.values),
    };
    fetch(`${url}user/login_dashboard`, requestOptions)
      .then((respone) => {
        if (!respone.ok) throw Error(respone.statusText);
        return respone.json();
      })
      .then((json) => {
        dispatch({ type: "DATA_FETCH_SUCCESS", payload: json });
        if (json.data.success === "1") {
          localStorage.setItem("token", json.data.auth);
          funcPermission();
        } else if (json.data.success === "0") {
          notifications.show({
            title: "แจ้งเตือน",
            message:
              "ไม่สามารถเข้าระบบได้ กรุณาตรวจสอบข้อมูลผู้ใช้ใหม่อีกครั้ง",
            autoClose: 3000,
            color: "red",
          });
        }
      })
      .catch((error) => {
        dispatch({ type: "DATA_FETCH_FAILURE", payload: error.message });
      });
  };

  const funcPermission = () => {
    dispatch({ type: "DATA_FETCH_START" });
    const token = localStorage.getItem("token");
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    fetch(`${url}user/premission`, requestOptions)
      .then((respone) => {
        if (!respone.ok) throw Error(respone.statusText);
        return respone.json();
      })
      .then((json) => {
        dispatch({ type: "DATA_FETCH_SUCCESS", payload: json });
        if (json.data.success === "1") {
          localStorage.setItem("dataUser", JSON.stringify(json.data.data));
          notifications.show({
            title: "เข้าระบบสำเร็จ",
            message: "กรุณารอสักครู่ กำลังเข้าหน้าผู้ใช้งาน",
            autoClose: 3000,
            icon: <IconCircleCheck />,
            color: "green",
          });
          nav("/dashboard");
        } else if (json.success === "0") {
          notifications.show({
            title: "แจ้งเตือน",
            message:
              "ไม่สามารถเข้าระบบได้ กรุณาตรวจสอบข้อมูลผู้ใช้ใหม่อีกครั้ง",
            autoClose: 3000,
            color: "red",
            icon: <IconAlertCircle />,
          });
        }
      })
      .catch((error) => {
        dispatch({ type: "DATA_FETCH_FAILURE", payload: error.message });
      });
  };

  useEffect(() => {
    LoadPage();
  }, []);

  const LoadPage = () => {
    localStorage.clear();
  };

  const icon = <IconInfoCircle />;

  return (
    <div className="LoginPage">
      <Box mx="auto" className="LoginBox">
        <form onSubmit={form.onSubmit(funcSubmit)}>
          <Center>
            <Image src={logo} w={100} alt="Logo" />
          </Center>
          <h1>ลงทะเบียนบัณฑิต</h1>
          <h2>เข้ารับพระราชทานปริญญาบัตร</h2>
          <h3>มหาวิทยาลัยราชภัฏกำแพงเพชร</h3>
          {/* <Alert variant="light" color="pink" title="Alert title" icon={icon}>
      ปิดรับลงทะเบียนแล้ว
    </Alert> */}
          <TextInput
            withAsterisk
            label="รหัสบัตรประจำตัวประชาชน"
            mt="md"
            placeholder="รหัสบัตรประจำตัวประชาชน"
            {...form.getInputProps("username")}
          />
          <Group justify="right" mt="md">
            <Button
              type="submit"
              fullWidth
              loading={data.loading}
              gradient={{ from: "teal", to: "blue", deg: 60 }}
            >
              ตรวจสอบ
            </Button>
          </Group>
          <Group justify="right" mt="md">
            <Link to="/loginAuth"></Link>
          </Group>
        </form>
      </Box>
    </div>
  );
}
